export const triggerErrorShake = (cssSelector = ".app-root", ms = 300) => {
  const elem = document.querySelectorAll(cssSelector)[0];
  console.log(elem, cssSelector);
  if (!elem) return;

  elem.classList.add("error-shake");

  // Remove class after animation completes to allow re-triggering
  setTimeout(() => {
    elem.classList.remove("error-shake");
  }, ms);
};
